import news from "@/http/requests/news"

export default {
  fetch({ commit }, queryData) {
    return new Promise((resolve, reject) => {
      news.fetch(queryData).then(response => {
        commit('SET_NEWS', response.data.data.news)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  fetchHighlighted({ commit }, queryData) {
    return new Promise((resolve, reject) => {
      news.fetch(queryData).then(response => {
        commit('SET_HIGHLIGHTED_NEWS', response.data.data.news)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  fetchMain({ commit }, queryData) {
    return new Promise((resolve, reject) => {
      news.fetch(queryData).then(response => {
        commit('SET_MAIN_NEWS', response.data.data.news)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  add({ commit }, data) {
    return new Promise((resolve, reject) => {
      news.add(data).then(response => {
        commit('ADD_NEWS', response.data.data.createNews)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  update({ commit }, data) {
    return new Promise((resolve, reject) => {
      news.update(data).then(response => {
        commit('UPDATE_NEWS', response.data.data.updateNews)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  delete({ commit }, newsId) {
    return new Promise((resolve, reject) => {
      news.delete(newsId).then(response => {
        commit('DELETE_NEWS', newsId)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  infos({ commit }, newsId) {
    return new Promise((resolve, reject) => {
      news.infos(newsId).then(response => {
        commit('ADD_NEWS_INFOS', response.data.data.newsInfos)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  }
}
